import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMozzoInternalUserRoleLabel } from '../../services/local/accessControl';

function LocalPersonnelTestSessionBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [returningToPersonnel, setReturningToPersonnel] = useState(false);
  const {
    exitLocalPersonnelTestProfile,
    isLocalPersonnelTestMode,
    localPersonnelTestProfile,
  } = useAuth();

  useEffect(() => {
    if (
      !returningToPersonnel ||
      isLocalPersonnelTestMode ||
      location.pathname === '/mozo' ||
      location.pathname === '/cocina'
    ) {
      return;
    }

    setReturningToPersonnel(false);
    navigate('/app/personal', { replace: true });
  }, [
    isLocalPersonnelTestMode,
    location.pathname,
    navigate,
    returningToPersonnel,
  ]);

  if (!isLocalPersonnelTestMode || !localPersonnelTestProfile) {
    return null;
  }

  const handleExit = () => {
    setReturningToPersonnel(true);
    exitLocalPersonnelTestProfile();
  };

  return (
    <aside style={styles.bar} aria-label="Sesion local de prueba">
      <span style={styles.pulse} />
      <div style={styles.identity}>
        <small style={styles.eyebrow}>Prueba local activa</small>
        <strong style={styles.name}>{localPersonnelTestProfile.fullName}</strong>
        <span style={styles.meta}>
          {getMozzoInternalUserRoleLabel(localPersonnelTestProfile.roleKey)} ·{' '}
          {localPersonnelTestProfile.branchName || 'Sucursal local'}
        </span>
      </div>
      <button type="button" style={styles.button} onClick={handleExit}>
        Volver al admin de pruebas
      </button>
    </aside>
  );
}

const styles = {
  bar: {
    position: 'fixed',
    right: '18px',
    bottom: '18px',
    zIndex: 100000,
    width: 'min(430px, calc(100vw - 36px))',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr) auto',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 13px',
    borderRadius: '16px',
    border: '1px solid #fdba74',
    background: 'rgba(255, 247, 237, 0.97)',
    boxShadow: '0 18px 45px rgba(124, 45, 18, 0.2)',
    color: '#431407',
    backdropFilter: 'blur(12px)',
  },
  pulse: {
    width: '10px',
    height: '10px',
    borderRadius: '999px',
    background: '#f97316',
    boxShadow: '0 0 0 5px rgba(249, 115, 22, 0.14)',
  },
  identity: { minWidth: 0, display: 'grid', gap: '1px' },
  eyebrow: {
    color: '#c2410c',
    fontSize: '9px',
    fontWeight: 900,
    letterSpacing: '0.09em',
    textTransform: 'uppercase',
  },
  name: {
    overflow: 'hidden',
    color: '#431407',
    fontSize: '13px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  meta: {
    overflow: 'hidden',
    color: '#9a3412',
    fontSize: '10px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  button: {
    border: '1px solid #fb923c',
    borderRadius: '10px',
    padding: '9px 11px',
    background: '#fff',
    color: '#9a3412',
    fontSize: '11px',
    fontWeight: 850,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
};

export default LocalPersonnelTestSessionBar;
